module.exports = __webpack_public_path__ + "img/magento-logo.2e23ab0b.svg";